export default {
      id: "ar_famille-usage",
      viewBox: "0 0 90 90",
      url: "../dist/images/" + "sprite.svg#ar_famille-usage",
      toString: function () {
        return this.url;
      }
    }